<template>
  <div class="field">
    <label class="label" v-if="false">{{ placeholder }}</label>
    <div class="control has-icon has-icon-right">
      <input v-if="type === 'email'" class="input" type="email" :name="name"
        :class="[name +'-input', { 'is-danger': error }]"
        :value="value"
        @input="onInput"
        :placeholder="placeholder"
        :required="required"
        :disabled="disabled"
        :autofocus="autofocus"></input>
      <input v-else-if="type === 'password'" class="input" type="password" :name="name"
        :class="[name +'-input', { 'is-danger': error }]"
        :value="value"
        @input="onInput"
        :placeholder="placeholder"
        :required="required"
        :disabled="disabled"
        :autofocus="autofocus"></input>
      <input v-else class="input" type="text" :name="name"
        :class="[name +'-input', { 'is-danger': error }]"
        :value="value"
        @input="onInput"
        :placeholder="placeholder"
        :required="required"
        :disabled="disabled"
        :autofocus="autofocus"></input>
      <span class="icon">
        <i class="fa" :class="[ 'fa-' + fa ]" :name="fa" v-if="false"></i>
        <i class="material-icons" v-if="mdi !== undefined">{{ mdi }}</i>
      </span>
      <form-error v-if="error" :error="error">
      </form-error>
    </div>
  </div>
</template>

<script>
// import Vue from 'vue'
export default {
  props: {
    type: {
      default: 'text'
    },
    name: {
      default: 'invalid'
    },
    mdi: {
      default: 'error_outline'
    },
    placeholder: {
      default: 'invalid'
    },
    value: {
      default: 'invalid'
    },
    error: {
      default: undefined
    },
    required: {
      default: true
    },
    disabled: {
      default: false
    },
    autofocus: {
      default: false
    }
  },
  data () {
    return {
      model: ''
      // value: 'invalid@invalid.com'
      // name: 'invalid',
      // type: 'invalid',
      // fa: 'error',
      // placeholder: 'invalid',
      // error: undefined
    }
  },
  computed: {
  },
  methods: {
    onInput (event) {
      this.model = event.target.value
      this.$emit('onInput', { name: this.name, value: this.model })
    }
  },
  created () {
  },
  mounted () {
  },
  watch: {
    value: function (val, old) {
      // to tally with external value
      this.model = this.value

      // do not echo back!
      // this.$emit('onInput', { name: this.name, value: val })
    },
    model: function (val, old) {
      // do not echo back!
      // this.$emit('onInput', { name: this.name, value: val })
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// FormInput.vue?415437d5